<canvas #canvas id="inputCanvas"></canvas>
<div class="white-overlay" *ngIf="disabled"></div>
<img #drawHere src="../assets/draw-here.png" (load)="drawPlaceholderIfClean()"/>
